import { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import SearchInput from "../../Components/SearchInput";
import CustomizeTableview from "../../Components/TableViews/CustomizeTableview";
import { useSelector } from "react-redux";
import PaginationBar from "../../Components/PaginationBar";
import SearchableSelect from "../../Components/SearchableSelect";
import NoResult from "../../Components/NoResult";
import ReactSelect from "../../Components/ReactSelect";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TIMEOUT } from "../../Features/dateTime";
import DatePicker from "../../Components/DatePicker/DatePicker";
import moment from "moment/moment";
import Loader from "../../Components/Loader";
import * as api from "../../api/getapi";
import useApi from "../../Hooks/useApi";
import * as postapi from "../../api/postapi";
import DeliveryForYouOrdersReasonModal from "./DeliveryForYouOrdersReasonModal";
import PhoneInput from "../../Components/PhoneInput/PhoneInput";
import StatusChangeConfirmationModal from "./StatusChangeConfirmationModal";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faGear, faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import OrdersConfigurationModal from "../../Components/OrdersConfiguration/OrdersConfigurationModal";
import FulfilledByTMModal from "../../Components/DeliveryForYouOrders/FulfilledByTMModal";
import SendSmsModal from "../../Components/DeliveryForYouOrders/SendSmsModal";
import MarkSpamModal from "../../Components/DeliveryForYouOrders/MarkSpamModal";
import ShipWithPostexModal from "../../Components/DeliveryForYouOrders/ShipWithPostexModal";
import { toast } from "react-toastify";
import { TRX_METHOD, normalizePaymentStatus, PAYMENT_STATUS } from "../../constants/orders";

const LegacyDeliveryForYouOrders = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const fetchAllCategories = useApi(api.fetchAllCategories);
  const fetchAllOrders = useApi(api.LegacyfetchAllOrders, { hasCatchError: true });

  const { user } = useSelector((state) => state.auth);
  const shop_id = user.shop_id;

  const [noOfPages, setNoOfPages] = useState(1);
  const [sizeOfPages, setSizeOfPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [toggle, refresh] = useState(false);
  const [statusSearch, setStatusSearch] = useState({ value: null, label: "All Statuses" });
  const [paymentMethodSearch, setPaymentMethodSearch] = useState({ value: null, label: "All Payment Methods" });
  const [isLoading, setIsLoading] = useState(true);
  const [orderBy, setOrderBy] = useState({ created_at: "DESC" });
  const [category, setCategory] = useState(null);
  const [orders, setOrders] = useState([]);
  const [ordersData, setOrdersData] = useState({});
  const [totalOrders, setTotalOrders] = useState();
  const [fromDate, setFromDate] = useState(moment().subtract(100, "years")._d);
  const [toDate, setToDate] = useState(moment().add(100, "years")._d);
  const [reasonModal, setReasonModal] = useState(false);
  const [orderReason, setOrderReason] = useState({
    orderId: null,
    status: null,
  });
  const [paymentGatewayResponse, setPaymentGatewayResponse] = useState(null);
  const [phoneSearch, setPhoneSearch] = useState("");
  const [changeStatusModal, setChangeStatusModal] = useState(false);
  const [isActionPerforming, setIsActionPerforming] = useState(false);
  const [orderConfigurationModalOpen, setOrderConfigurationModalOpen] = useState(false);
  const [techbazaarMallModalOpen, setTechbazaarMallModalOpen] = useState(false);

  // Search Products
  const searchHandle = (e) => {
    e.preventDefault();
    if (e.target.value === "") {
      setSearch("");
    } else {
      setSearch(e.target.value);
    }
    setCurrentPage(1);
  };

  const searchStatus = (e) => {
    if (e.value) {
      setStatusSearch({ value: e.value, label: e.label });
    } else {
      setStatusSearch({ value: null, label: "All Statuses" });
    }
    setCurrentPage(1);
  };

  const searchPaymentMethod = (e) => {
    if (e.value) {
      setPaymentMethodSearch({ value: e.value, label: e.label });
    } else {
      setPaymentMethodSearch({ value: null, label: "All Payment Methods" });
    }
    setCurrentPage(1);
  };

  const getCat = async () => {
    return new Promise((resolve, reject) => {
      fetchAllCategories
        .request()
        .then((res) => {
          const getData = res.data.data
            .filter((cat) => cat.id !== 7)
            .map((cat) => ({
              value: cat.id,
              label: cat.category,
            }));
          getData.splice(0, 0, { value: null, label: "All" });
          resolve(getData);
        })
        .catch((err) => {
          reject("err" + err);
        });
    });
  };
  const filterCategories = (e) => {
    if (e.value) {
      setCategory({ value: e.value, label: e.label });
    } else {
      setCategory(null);
    }
    setCurrentPage(1);
  };

  const resetFilterHandle = (e) => {
    setStatusSearch({ value: null, label: "All Statuses" });
    setCategory(null);
    setFromDate(moment().subtract(100, "years")._d);
    setToDate(moment().add(100, "years")._d);
    setSizeOfPages(10);
    setCurrentPage(1);
  };

  const changePage = (page) => {
    setCurrentPage(page);
  };

  //searchParams
  useEffect(() => {
    if (searchParams.get("page")) {
      setCurrentPage(Number(searchParams.get("page")));
    }
  }, [currentPage, toggle, searchParams]);

  function getDeliverForYouOrders() {
    try {
      let phoneNumber = phoneSearch.replaceAll("_", "");
      if (phoneNumber.endsWith("-")) {
        phoneNumber = phoneNumber.slice(0, -1);
      }
      fetchAllOrders
        .request({
          page: currentPage,
          size: sizeOfPages,
          search: search,
          status: statusSearch,
          category: category,
          fromDate: fromDate,
          toDate: toDate,
          orderBy: orderBy,
          phone: phoneNumber,
          paymentMethod: paymentMethodSearch.value,
        })
        .then((data) => {
          setIsLoading(false);
          setTotalOrders(data?.data?.pagination?.no_of_items);
          setOrders(data?.data?.data);

          if (data?.data?.pagination?.no_of_pages === 0) {
            if (searchParams.get("page")) {
              setNoOfPages(0);
              navigate("/delivery-for-you-orders?page=0");
            }
          } else {
            setNoOfPages(data?.data?.pagination?.no_of_pages);
            if (currentPage > data?.data?.pagination?.no_of_pages) {
              setCurrentPage(data?.data?.pagination?.no_of_pages);
              navigate("/delivery-for-you-orders?page=" + data?.data?.pagination?.no_of_pages);
            }
            if (searchParams.get("page") === "0") {
              setCurrentPage(1);
              navigate("/delivery-for-you-orders?page=1");
            }
          }
        })
        .catch((err) => {
          const tempErr = err.response.data.error;

          if (tempErr.status === 404 && tempErr.message === "No Record Found") {
            setOrders([]);
            setIsLoading(false);
          }
        });
    } catch (err) {
      const tempErr = err.response.data.error;

      if (tempErr.status === 404 && tempErr.message === "No Record Found") {
        setOrders([]);
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    let timeout;
    if (search?.length > 0) {
      timeout = setTimeout(() => {
        setIsLoading(true);
        getDeliverForYouOrders();
      }, TIMEOUT);
    } else {
      setIsLoading(true);
      getDeliverForYouOrders();
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [search, fromDate, toDate, currentPage, noOfPages, sizeOfPages, statusSearch, shop_id, toggle, orderBy, category, phoneSearch, paymentMethodSearch]);

  useEffect(() => {
    if (currentPage === 1) {
      refresh((prev) => !prev);
    } else {
      changePage(1);
    }
  }, [search, fromDate, toDate, statusSearch, category, phoneSearch]);

  const caret = async (orderId) => {
    const data = orders.filter((item) => item.id === orderId);
    const { customer_name, customer_email, customer_phone, customer_address, notes, seller_name, seller_phone, seller_address, reason, postman_name, postman_phone, ...ordersObj } = data[0];
    setOrdersData({
      customer_name,
      customer_email,
      customer_phone,
      customer_address,
      notes,
      seller_name,
      seller_phone,
      seller_address,
      reason,
      postman_name,
      postman_phone,
    });
  };
  const reasonHandle = (id, status) => {
    if (status === "Cancelled" || status === "Returned") {
      setReasonModal(true);
      setOrderReason({
        orderId: id,
        status: status,
      });
    }
  };

  const FetchOrderByRRN = async (orderId) => {
    try {
      const res = await axios.get(`https://payments.bankalfalah.com/HS/api/IPN/OrderStatus/210743/399691/${orderId}`, {
        headers: {
          Accept: "application/json",
        },
      });
      return res;
    } catch (error) {
      console.error("Error fetching order by RRN:", error);
      throw error;
    }
  };

  const getNextStatus = (currentStatus) => {
    const statusMap = {
      "Verifying Payment": "Confirmed",
      Pending: "Confirmed",
      Confirmed: "Picked",
      Picked: "Shipped",
      Shipped: "Delivered",
    };
    return statusMap[currentStatus] || null;
  };

  const refreshHandle = () => {
    refresh((prev) => !prev);
  };
  const handleStatusModal = (value) => {
    if (value["trx_method"] === TRX_METHOD.CASH) {
      const nextStatus = getNextStatus(value["status"]);
      if (nextStatus) {
        setChangeStatusModal(true);
        setOrderReason({
          orderId: value["id"],
          status: nextStatus,
        });
      }
    } else if (value["trx_method"] === TRX_METHOD.CARD || value["trx_method"] === TRX_METHOD.CARD_BNPL || value["trx_method"] === TRX_METHOD.RAAST) {
      setIsActionPerforming(true);
      FetchOrderByRRN(value["order_number"])
        .then((res) => {
          const data = JSON.parse(res.data);
          // Normalize status from either Abhipay or Alfalah gateway
          const normalizedTrxStatus = normalizePaymentStatus(data?.TransactionStatus);
          const nextStatus = getNextStatus(value["status"]);

          if (!nextStatus) {
            setIsActionPerforming(false);
            return;
          }

          // Store the gateway response to show in modal
          setPaymentGatewayResponse(data);
          setChangeStatusModal(true);

          // If payment status changed or it's the first verification, include trx_status
          if (normalizedTrxStatus !== value["trx_status"] || value["status"] === "Verifying Payment" || value["status"] === "Pending") {
            setOrderReason({
              orderId: value["id"],
              status: nextStatus,
              trx_status: normalizedTrxStatus,
            });
          } else {
            setOrderReason({
              orderId: value["id"],
              status: nextStatus,
            });
          }

          setIsActionPerforming(false);
        })
        .catch((error) => {
          console.error("Failed to fetch order status:", error);
          setIsActionPerforming(false);
          setPaymentGatewayResponse(null);
          // Optionally show error notification to user
        });
    } else if (value["trx_method"] === TRX_METHOD.BANK_TRANSFER) {
      const nextStatus = getNextStatus(value["status"]);
      if (nextStatus) {
        setChangeStatusModal(true);
        setOrderReason({
          orderId: value["id"],
          status: nextStatus,
        });
      }
    }
  };
  const handleConfigurationModal = () => {
    setOrderConfigurationModalOpen(true);
  };
  const handleFullfilledByTMModal = () => {
    setTechbazaarMallModalOpen(true);
  };

  const [smsModalState, setSmsModaState] = useState(null);
  const [smsModalShow, setSmsModalShow] = useState(false);
  const [spamModalShow, setSpamModalShow] = useState(false);
  const [postexModalShow, setPostexModalShow] = useState(false);
  const [postexOrder, setPostexOrder] = useState(null);

  const closeSmsModal = () => {
    setSmsModalShow(false);
    setSmsModaState(null);
  };

  const closeSpamModal = () => {
    setOrdersData(null);
    setSpamModalShow(false);
  };

  return (
    <>
      <Container fluid>
        <Row className="d-flex align-items-center">
          <Col xs="2" lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <SearchInput value={search} searchlogo handleChange={searchHandle} />
          </Col>
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <PhoneInput placeholder="+92-3XX-XXXXXXX" value={phoneSearch} onChange={(e) => setPhoneSearch(e.target.value)} required />
          </Col>
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <DatePicker important={true} fromDate={fromDate} toDate={toDate} setFromDate={setFromDate} setToDate={setToDate} />
          </Col>
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <ReactSelect placeholder="Filter Category" value={category} searchable={true} options={getCat} handleChange={filterCategories} />
          </Col>

          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <SearchableSelect
              placeholder="Filter Status"
              searchable={false}
              value={statusSearch}
              options={[
                { value: null, label: "All Statuses" },
                { value: "Pending", label: "Pending" },
                { value: "Confirmed", label: "Confirmed" },
                { value: "Picked", label: "Picked" },
                { value: "Shipped", label: "Shipped" },
                { value: "Delivered", label: "Delivered" },
                { value: "Cancelled", label: "Cancelled" },
                { value: "Returned", label: "Returned" },
                { value: "Verifying Payment", label: "Verifying Payment" },
                { value: "Payment Failed", label: "Payment Failed" },
              ]}
              handleChange={searchStatus}
            />
          </Col>
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <SearchableSelect
              placeholder="Filter Status"
              searchable={false}
              value={paymentMethodSearch}
              options={[
                { value: null, label: "All Payment Methods" },
                { value: "Bank Transfer", label: "Bank Transfer" },
                { value: "Cash", label: "Cash" },
                { value: "Card", label: "Card" },
                { value: "Card - BNPL", label: "Card - BNPL" },
                { value: "Raast", label: "Raast" },
              ]}
              handleChange={searchPaymentMethod}
            />
          </Col>
          <Col className="d-none d-sm-inline d-lg-none d-md-inline px-0" sm={2}></Col>
          <Col xs="6" lg="3" xl="2" sm="3" className="mb-3">
            <SearchableSelect
              selectClassName={"bg-white"}
              placeholder={`Showing ${sizeOfPages}`}
              defaultValue={`Showing ${sizeOfPages}`}
              value={`Showing ${sizeOfPages}`}
              searchable={false}
              options={[
                { value: "10", label: "10" },
                { value: "20", label: "20" },
                { value: "30", label: "30" },
              ]}
              handleChange={(e) => setSizeOfPages(e.value)}
            />
          </Col>
        </Row>
        <div className="pt-2 d-flex justify-content-between">
          <div className="d-flex gap-2">
            <Button size="sm" type="submit" style={{ fontSize: "14px" }} onClick={resetFilterHandle}>
              <span className="d-lg-inline">Reset Filters</span>
            </Button>
            <Button size="sm" variant="outline-secondary" style={{ fontSize: "14px" }} onClick={() => refresh((prev) => !prev)}>
              <FontAwesomeIcon icon={faArrowsRotate} />
              <span className="ps-1 d-lg-inline">Refresh</span>
            </Button>
          </div>
          <div>
            <Button
              size="sm"
              type="submit"
              style={{ fontSize: "14px", marginRight: "10px" }}
              onClick={() => {
                navigate("/delivery-for-you/orders/create");
              }}
            >
              <span className="d-lg-inline">Create Order</span>
            </Button>
            <Button size="sm" variant="outline-primary" style={{ fontSize: "14px", marginRight: "10px" }} onClick={handleFullfilledByTMModal}>
              <FontAwesomeIcon icon={faEdit} />
              <span className="ps-1">Fulfilled By Techbazaar Mall</span>
            </Button>
            <Button size="sm" variant="outline-primary" style={{ fontSize: "14px" }} onClick={handleConfigurationModal}>
              <FontAwesomeIcon icon={faGear} />
              <span className="ps-1">Order Configuration</span>
            </Button>
          </div>
        </div>

        {isLoading ? (
          <div
            style={{
              height: "50vh",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Loader />
          </div>
        ) : orders?.length === 0 ? (
          <NoResult />
        ) : (
          <>
            <CustomizeTableview
              className={"mt-3"}
              data={orders}
              caret={caret}
              caretData={ordersData}
              link={[
                { label: "View Listing", column: "listing_url" },
                {
                  label: "View Proof",
                  column: "trx_proof",
                  fallback: "Not Available",
                },
              ]}
              columnNotShow={[
                "id",
                "item_name",
                "fk_customer_id",
                "fk_handler_id",
                "fk_item_id",
                "fk_listing_id",
                "fk_location_id",
                "fk_shop_id",
                "fk_voucher_id",
                "trx_refund_id",
                "trx_session_id", // removed after APG integration
                "trx_uuid", // removed after APG integration
                "is_deleted",
                "deleted_at",
                "status",
                "customer_name",
                "customer_email",
                "customer_phone",
                "customer_address",
                "notes",
                "seller_name",
                "seller_phone",
                "seller_address",
                "sales_order_id",
                "reason",
                "postman_name",
                "postman_phone",
                "is_spam",
                "postex_tracking_number",
              ]}
              datetimeColumn={["created_at", "updated_at"]}
              sortColumn={["created_at", "updated_at", "item_name", "quantity", "price", "total_price", "stock_no"]}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
              status={{
                column: ["status", "created_at", "trx_status"],
                getClassName: ({ status, trx_status }) => {
                  if (status === "Delivered") {
                    return "text-success";
                  } else if (status === "Pending") {
                    return "text-warning";
                  } else if (status === "Cancelled") {
                    return "text-danger";
                  } else if (status === "Picked") {
                    return "text-info";
                  } else if (status === "Confirmed") {
                    return "text-primary";
                  } else if (status === "Shipped") {
                    return "text-secondary";
                  } else if (status === "Returned") {
                    return "text-danger";
                  } else if (trx_status === PAYMENT_STATUS.DECLINED || trx_status === PAYMENT_STATUS.EXPIRED || trx_status === PAYMENT_STATUS.CREATED) {
                    return "text-danger";
                  } else if (status === "Verifying Payment") {
                    return "text-warning";
                  }
                },
                format: ({ status, trx_status }) => {
                  if (status === "Delivered") {
                    return "Delivered";
                  } else if (status === "Pending") {
                    return "Pending";
                  } else if (status === "Cancelled") {
                    return "Cancelled";
                  } else if (status === "Picked") {
                    return "Picked";
                  } else if (status === "Confirmed") {
                    return "Confirmed";
                  } else if (status === "Shipped") {
                    return "Shipped";
                  } else if (status === "Returned") {
                    return "Returned";
                  } else if (trx_status === PAYMENT_STATUS.DECLINED || trx_status === PAYMENT_STATUS.EXPIRED || trx_status === PAYMENT_STATUS.CREATED) {
                    return status;
                    // return "Payment Failed";
                  } else if (status === "Verifying Payment") {
                    return "Verifying Payment";
                  }
                },
              }}
              formattedColumn={{
                heading: "Is Spam",
                style: (row) => {
                  const isSpam = row["is_spam"];
                  if (isSpam === 0) {
                    return "text-success";
                  } else {
                    return "text-danger";
                  }
                },
                format: (row) => {
                  const isSpam = row["is_spam"];
                  if (isSpam === 0) {
                    return "Not Spam";
                  } else {
                    return "Spam";
                  }
                },
              }}
              // cancel={(value) => reasonHandle(value["id"], "Cancelled")}
              cancel={{
                action: (value) => reasonHandle(value, "Cancelled"),
                isShow: ({ status, trx_status }) => {
                  if ((status === "Verifying Payment" && trx_status === PAYMENT_STATUS.PENDING) || ["Delivered", "Returned", "Cancelled", "Refunded"].includes(status)) {
                    return false;
                  } else {
                    return true;
                  }
                },
                disabled: (value) => value["status"] === "Cancelled" || value["status"] === "Delivered" || value["status"] === "Returned" || value["status"] === "Payment Failed" || value["status"] === "Refunded",
              }}
              returned={(value) => reasonHandle(value["id"], "Returned")}
              actionButton={{
                column: ["status", "sales_order_id", "trx_status", "trx_method", "is_spam"],
                label: (value) => {
                  const status = value["status"];
                  const trxStatus = value["trx_status"];
                  const trxMethod = value["trx_method"];

                  // Hide button for these cases
                  if (
                    status === "Payment Failed" ||
                    (status === "Verifying Payment" && trxStatus === PAYMENT_STATUS.EXPIRED && trxMethod !== TRX_METHOD.BANK_TRANSFER) ||
                    (status === "Verifying Payment" && trxStatus === PAYMENT_STATUS.PENDING && trxMethod !== TRX_METHOD.BANK_TRANSFER) ||
                    (status === "Pending" && (trxMethod === TRX_METHOD.CARD || trxMethod === TRX_METHOD.CARD_BNPL || trxMethod === TRX_METHOD.RAAST))
                  ) {
                    return "";
                  }

                  // Show "Confirm" button for these cases
                  if (
                    (status === "Verifying Payment" && [PAYMENT_STATUS.SETTLE_PENDING, PAYMENT_STATUS.APPROVED, PAYMENT_STATUS.SETTLED].includes(trxStatus)) ||
                    (status === "Pending" && trxMethod === TRX_METHOD.CASH) ||
                    (status === "Pending" && trxMethod === TRX_METHOD.BANK_TRANSFER) ||
                    (status === "Verifying Payment" && trxMethod === TRX_METHOD.BANK_TRANSFER)
                  ) {
                    return "Confirm";
                  }

                  // Progress to next steps
                  if (status === "Confirmed") return "Picked";
                  if (status === "Picked") return "Shipped";
                  if (status === "Shipped") return "Delivered";
                },
                onClick: async (er, value) => {
                  handleStatusModal(value);
                },
                extraButton: {
                  label: (value) => value["status"] === "Picked" ? "Ship With PostEx" : "",
                  onClick: (value) => {
                    setPostexOrder(value);
                    setPostexModalShow(true);
                  },
                  variant: "outline-secondary",
                  isShow: (_, row) => row["status"] === "Picked" && row["is_spam"] === 0,
                  disabled: () => false,
                },
                variant: "outline-primary",
                disabled: (value) => isActionPerforming || value["status"] === "Cancelled" || value["status"] === "Delivered" || value["status"] === "Returned" || (value["status"] === "Confirmed" && value["sales_order_id"] === null),
                isShow: (_, row) => {
                  return (
                    row?.["is_spam"] === 0 &&
                    row?.["status"] !== "Cancelled" &&
                    row?.["status"] !== "Delivered" &&
                    row?.["status"] !== "Returned" &&
                    row?.["status"] !== "Payment Failed" &&
                    row?.["status"] !== "Refunded" &&
                    !(row?.["status"] === "Pending" && (row?.["trx_method"] === TRX_METHOD.CARD || row?.["trx_method"] === TRX_METHOD.CARD_BNPL || row?.["trx_method"] === TRX_METHOD.RAAST))
                  );
                },
              }}
              spamButton={{
                column: ["is_spam", "status"],
                onClick: async (value) => {
                  setOrdersData(value);
                  setSpamModalShow(true);
                },
                variant: "outline-primary",
                isShow: (row) => {
                  return row["is_spam"] === 0 && row["status"] !== "Delivered";
                },
              }}
              smsButton={{
                onClick: async (value) => {
                  setSmsModaState(value);
                  setSmsModalShow(true);
                },
                variant: "outline-primary",
                isShow: (row) => {
                  return true;
                },
              }}
              airwayBillButton={{
                variant: "outline-secondary",
                isShow: (row) => !!row["postex_tracking_number"],
                onClick: async (row) => {
                  try {
                    const res = await postapi.getPostexAirwayBill(row["postex_tracking_number"]);
                    const blob = new Blob([res.data], { type: "application/pdf" });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `airway-bill-${row["postex_tracking_number"]}.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                  } catch (err) {
                    toast.error("Failed to download airway bill.");
                  }
                },
              }}
              trackingNumberButton={{
                isShow: (row) => !!row["postex_tracking_number"],
                getLabel: (row) => row["postex_tracking_number"],
                getTooltip: (row) => `Copy: ${row["postex_tracking_number"]}`,
                onClick: (row) => {
                  navigator.clipboard.writeText(row["postex_tracking_number"]).then(() => {
                    toast.success(`Tracking number copied: ${row["postex_tracking_number"]}`, {
                      position: "bottom-right",
                      autoClose: 1500,
                      hideProgressBar: true,
                    });
                  }).catch(() => {
                    toast.error("Failed to copy tracking number.");
                  });
                },
              }}
            />
            <Row className="mt-5 align-items-center">
              <Col className="d-none d-md-block" md="3" lg="3">
                <span className="text-secondary fs-6">{totalOrders} result(s)</span>
              </Col>
              <Col xs="12" md="6" lg="6">
                <PaginationBar currentPage={currentPage} noOfPages={noOfPages} changePage={changePage} />
              </Col>
              <Col className="d-md-none d-flex align-items-center mt-3" xs="6" lg="3">
                <span className="text-secondary fs-6">{totalOrders} result(s)</span>
              </Col>
            </Row>
          </>
        )}
      </Container>
      <DeliveryForYouOrdersReasonModal
        show={reasonModal}
        onHide={() => {
          setReasonModal(false);
          setOrderReason({
            orderId: null,
            status: null,
          });
        }}
        toggle={refreshHandle}
        id={orderReason?.orderId}
        status={orderReason?.status}
        trx_status={orderReason?.trx_status}
      />
      <StatusChangeConfirmationModal
        show={changeStatusModal}
        onHide={() => {
          setChangeStatusModal(false);
          setOrderReason({
            orderId: null,
            status: null,
          });
          setPaymentGatewayResponse(null);
        }}
        toggle={refreshHandle}
        id={orderReason?.orderId}
        status={orderReason?.status}
        trx_status={orderReason?.trx_status}
        paymentGatewayResponse={paymentGatewayResponse}
      />
      <OrdersConfigurationModal show={orderConfigurationModalOpen} onHide={() => setOrderConfigurationModalOpen(false)} toggle={refreshHandle} />
      <FulfilledByTMModal show={techbazaarMallModalOpen} onHide={() => setTechbazaarMallModalOpen(false)} toggle={refreshHandle} />
      <SendSmsModal show={smsModalShow} data={smsModalState} onHide={closeSmsModal} />
      <MarkSpamModal show={spamModalShow} data={ordersData} onHide={closeSpamModal} toggle={refreshHandle} />
      <ShipWithPostexModal
        show={postexModalShow}
        onHide={() => {
          setPostexModalShow(false);
          setPostexOrder(null);
        }}
        order={postexOrder}
        toggle={refreshHandle}
      />
    </>
  );
};
export default LegacyDeliveryForYouOrders;
